<template>
    <div class="thank-you__details__wrapper bordered-box__wrapper">
        <h3>Pickup</h3>
        <h4>Collection location</h4>
        <div class="thank-you__details__map">
            <iframe class="rounded" width="100%" height="150" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="mapSrc"></iframe>
        </div>

        <div class="thank-you__details__pickup">
            <div class="message-box">
                <div class="message-box__label medium">
                    We will notify you when your order is ready.
                    <br/>
                    <small style="font-weight:normal;"><em>Please bring a copy of your Order or identification.</em></small>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import {useCart} from '@/frontend/vue/composables/useCart'
import {computed, onMounted} from 'vue'

onMounted(() => {
    resetCart();
})

const props = defineProps({
    order: { type: Object, required: true },
    address: { type: String, required: true },
    store: { type: String, required: true },
})

const pickup_from = computed(() => {
    return props.address.street + ', ' + props.address.suburb + ', ' + props.address.state + ', ' + props.address.postcode;
});

const mapSrc = computed(() => {
    const base = 'https://maps.google.com/maps'
    const params = new URLSearchParams({
        width: '100%',
        height: '200',
        hl: 'en',
        q: pickup_from.value,
        t: '',
        z: '14',
        ie: 'UTF8',
        iwloc: 'B',
        output: 'embed'
    })
    return `${base}?${params.toString()}`
})

const {
    resetCart
} = useCart()

</script>
